import Empty from "./Empty";

const DocumentsEmptyState = () => (
  <Empty
    imageSrc="/img/glasses.png"
    maxWidth="370px"
    message="Please check your filters or wait for documents to be added."
    paddingTop={16}
  />
);

export default DocumentsEmptyState;
